import { rgba } from 'polished';
import React from 'react';
import { FormMessage } from '~/components';
import { colors } from '~/styles';

function resolveTimeTrackingMethods(item = {}) {
  return {
    trackTimeByDuration: !!(item?.timeTrackingMethods?.duration ?? item?.trackTimeByDuration),
    trackTimeByTimeRange: !!(item?.timeTrackingMethods?.timeRange ?? item?.trackTimeByTimeRange),
  };
}

function shouldShowTimerStopDisclaimer(item, updatedItem) {
  const timeTrackingMethods = resolveTimeTrackingMethods(item);
  const updatedTimeTrackingMethods = {
    trackTimeByDuration: updatedItem?.trackTimeByDuration ?? timeTrackingMethods.trackTimeByDuration,
    trackTimeByTimeRange: updatedItem?.trackTimeByTimeRange ?? timeTrackingMethods.trackTimeByTimeRange,
  };

  return (
    timeTrackingMethods.trackTimeByDuration !== updatedTimeTrackingMethods.trackTimeByDuration ||
    timeTrackingMethods.trackTimeByTimeRange !== updatedTimeTrackingMethods.trackTimeByTimeRange
  );
}

export default function TimeTrackingWarning({ item, updatedItem, context = 'workspace' }) {
  if (!shouldShowTimerStopDisclaimer(item, updatedItem)) return null;

  const contextMessage = context === 'member' ? 'for this member' : 'in this workspace';

  return (
    <FormMessage
      spaceTop
      variant="warning"
      style={{
        fontSize: '0.75rem',
        marginTop: '0.5rem',
        color: colors.black,
        backgroundColor: rgba(colors.warning, 0.18),
        fontWeight: 500,
      }}>
      Saving this change will stop any running timers {contextMessage}.
    </FormMessage>
  );
}

export { shouldShowTimerStopDisclaimer };
